/**
 * The persona list a tab may choose from (#1053 4b).
 *
 * Extracted from `ContextDock` so it can be DRIVEN: the console's suites run in
 * node with no DOM, so a memo inside a component that imports `@solum/ui` is
 * reachable only by reading its source text — which is how the case below went
 * unnoticed.
 *
 * The prepend keeps a persona this tab is ALREADY acting as visible even when
 * the catalogue no longer offers it; dropping it would render the acting value
 * as the placeholder, i.e. *absent* rather than *unusual* (the same argument
 * `Select`'s `selectable` carries for an archived option).
 *
 * It must NOT fire for the empty persona, which since 4b is the ordinary
 * opening state of a LIVE tab: nothing chosen here, so `describe_experience` is
 * called with no persona and the server answers for the person's own
 * `core.user_persona.is_default`. An empty acting value is not a persona worth
 * preserving — it adds a blank, unnamed row to the menu — and the trigger
 * already says "Persona" for it.
 *
 * ── MUTATION EVIDENCE (rule 10) — verdict is the child-process EXIT CODE ────
 * Run: `pnpm -C apps/console test personaOptions`
 *
 * | # | mutation | named red | exit |
 * |---|---|---|---|
 * | 1 | drop the `persona === ''` arm | *a tab with nothing chosen offers no blank row* | 1 |
 * | 2 | always prepend | *…and the acting persona is not repeated when the catalogue has it* | 1 |
 * | 3 | never prepend | *a persona the catalogue no longer offers stays visible while it is acting* | 1 |
 */
export interface PersonaOption { value: string; label: string }

export function personaOptions(persona: string, rows: PersonaOption[]): PersonaOption[] {
  if (persona === '' || rows.some((row) => row.value === persona)) return rows
  return [{ value: persona, label: persona }, ...rows]
}
